var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 114 129",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38419e-05 0H113.283L102.899 115.092L56.9561 128.073L10.1483 115.092L2.38419e-05 0ZM21.0832 23.2859H91.9637L85.5128 95.5824L56.6415 103.607L27.6127 95.5824L25.4887 73.5552H39.413L40.357 84.8048L56.6415 89.1316L72.4539 84.8048L74.1846 66.003H24.8593L23.522 51.9213H75.2859L76.5446 37.2889H22.2633L21.0832 23.2859Z",
    fill: "#F0E3CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.35864e17dc43363aed3351491d662048.svg";
export { ForwardRef as ReactComponent };